import axios from '@/libs/camera.request'

/**
 * 扫描文件
 */
export const takePictures = () => {
    const data ={
        "camidx": "0",
        "make_uuid": "1",
        "image_process_info": {
            "cut_type": "1",
            "rotate": "90"
        }
    }
    return axios.request({
        url: '/video=grabimage',
        data,
        method: 'post'
    })
}

/**
 * 合并成为Pdf
 */
export const mergeToPdf = (jsonArr) => {
    return axios.request({
        url: '/imagepro=merge2pdf',
        data: jsonArr,
        method: 'post'
    })
}